(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["galleria-con-overlay"] && !Shopify.designMode) return;
  try {
    
const modal = document.getElementById("imageModal");
const modalImg = document.getElementById("fullImage");
const captionText = document.getElementById("caption");
const galleryImages = [...document.querySelectorAll('.image-item img')];
const closeBtn = document.querySelector(".close");
const prevBtn = document.querySelector(".arrow.left");
const nextBtn = document.querySelector(".arrow.right");

let currentIndex = 0;
const imageCache = new Map();
let isLoading = false;
let isTransitioning = false;

// Precaricare l'immagine
function preloadImage(url) {
  if (imageCache.has(url)) {
    return Promise.resolve(imageCache.get(url));
  }
  
  return new Promise((resolve, reject) => {
    const img = new Image();
    img.onload = () => {
      imageCache.set(url, img);
      resolve(img);
    };
    img.onerror = reject;
    img.src = url;
  });
}

// Precaricare immagini adiacenti in background
function preloadAdjacentImages(index) {
  const nextIndex = (index + 1) % galleryImages.length;
  const prevIndex = (index - 1 + galleryImages.length) % galleryImages.length;
  
  // Precaricare le immagini full-size in background
  if (galleryImages[nextIndex]) {
    preloadImage(galleryImages[nextIndex].dataset.full).catch(() => {});
  }
  if (galleryImages[prevIndex]) {
    preloadImage(galleryImages[prevIndex].dataset.full).catch(() => {});
  }
}

// Precaricare tutte le immagini al caricamento pagina
function preloadAllImages() {
  galleryImages.forEach(img => {
    preloadImage(img.dataset.full).catch(() => {});
  });
}

function showModal(index) {
  // Evita lag da clic multipli
  if (isLoading || isTransitioning) return;
  
  const img = galleryImages[index];
  currentIndex = index;
  const fullUrl = img.dataset.full;
  
  isLoading = true;
  
  // Mostra subito la thumbnail
  modalImg.src = img.src;
  modalImg.style.opacity = "1";
  
  modal.style.visibility = "visible";
  modal.style.opacity = "0";
  
  // Usa setTimeout per evitare lag da requestAnimationFrame
  setTimeout(() => {
    modal.style.opacity = "1";
  }, 10);
  
  // Carica l'immagine full-size in background
  preloadImage(fullUrl).then(fullImg => {
    // Non applicare blur pesante - usa solo opacity
    modalImg.src = fullUrl;
    modalImg.setAttribute("width", fullImg.naturalWidth);
    modalImg.setAttribute("height", fullImg.naturalHeight);
    captionText.textContent = img.alt;
    isLoading = false;
    
    // Precaricare immagini adiacenti
    preloadAdjacentImages(index);
  }).catch(() => {
    isLoading = false;
  });
}

galleryImages.forEach((img, index) => {
  img.addEventListener("click", () => showModal(index));
  // Precaricare le immagini quando l'utente passa sopra
  img.addEventListener("mouseover", () => {
    preloadImage(img.dataset.full).catch(() => {});
  });
});

function closeModal() {
  isTransitioning = true;
  modal.style.opacity = "0";
  
  setTimeout(() => {
    modal.style.visibility = "hidden";
    isTransitioning = false;
  }, 250);
}

function showNext() {
  if (!isLoading && !isTransitioning) {
    currentIndex = (currentIndex + 1) % galleryImages.length;
    showModal(currentIndex);
  }
}

function showPrev() {
  if (!isLoading && !isTransitioning) {
    currentIndex = (currentIndex - 1 + galleryImages.length) % galleryImages.length;
    showModal(currentIndex);
  }
}

closeBtn.addEventListener("click", closeModal);
modal.addEventListener("click", (e) => {
  if (e.target === modal) closeModal();
});
nextBtn.addEventListener("click", showNext);
prevBtn.addEventListener("click", showPrev);
document.addEventListener("keydown", (e) => {
  if (e.key === "Escape") closeModal();
  if (e.key === "ArrowRight") showNext();
  if (e.key === "ArrowLeft") showPrev();
});

// Precaricare tutte le immagini quando la pagina è carica
if (document.readyState === "loading") {
  document.addEventListener("DOMContentLoaded", preloadAllImages);
} else {
  preloadAllImages();
}

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["video-overlay"] && !Shopify.designMode) return;
  try {
    
  class VideoOverlayModal {
    constructor() {
      this.triggers = document.querySelectorAll('[data-video-overlay-trigger]');
      this.bindEvents();
    }

    bindEvents() {
      this.triggers.forEach(trigger => {
        trigger.addEventListener('click', (e) => {
          e.preventDefault();
          const sectionId = trigger.dataset.videoOverlayTrigger;
          this.openModal(sectionId);
        });
      });

      document.addEventListener('click', (e) => {
        if (e.target.closest('[data-video-overlay-close]')) {
          const modal = e.target.closest('[data-video-overlay-modal]');
          if (modal) {
            this.closeModal(modal);
          }
        }
      });

      document.addEventListener('keydown', (e) => {
        if (e.key === 'Escape') {
          const openModal = document.querySelector('[data-video-overlay-modal][aria-hidden="false"]');
          if (openModal) {
            this.closeModal(openModal);
          }
        }
      });
    }

    openModal(sectionId) {
      const modal = document.getElementById(`video-overlay-modal-${sectionId}`);
      if (!modal) return;

      modal.setAttribute('aria-hidden', 'false');
      document.body.style.overflow = 'hidden';

      const video = modal.querySelector('[data-video-overlay-player]');
      if (video) {
        video.play().catch(() => {});
      }

      const closeButton = modal.querySelector('[data-video-overlay-close]');
      if (closeButton) {
        closeButton.focus();
      }
    }

    closeModal(modal) {
      modal.setAttribute('aria-hidden', 'true');
      document.body.style.overflow = '';

      const video = modal.querySelector('[data-video-overlay-player]');
      if (video) {
        video.pause();
        video.currentTime = 0;
      }

      const iframe = modal.querySelector('[data-video-overlay-iframe]');
      if (iframe) {
        const src = iframe.src;
        iframe.src = '';
        iframe.src = src;
      }

      const sectionId = modal.id.replace('video-overlay-modal-', '');
      const trigger = document.querySelector(`[data-video-overlay-trigger="${sectionId}"]`);
      if (trigger) {
        trigger.focus();
      }
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => new VideoOverlayModal());
  } else {
    new VideoOverlayModal();
  }

  } catch(e) { console.error(e); }
})();
})();
